import { changeDecimalString } from 'utils/formatting_utils';

const TableCellCurrencyFormatter = ({ value, maxLength, digits, component, prefix }) => {
	const currencyValue = changeDecimalString(value, maxLength, digits, component, prefix, true);

	return (
		<span className="table-cell__content" tabIndex="0">{currencyValue}</span>
	);
};

export default TableCellCurrencyFormatter;
